export const PORTRAIT =
  'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwY29ycG9yYXRlJTIwcG9ydHJhaXQlMjBtYW58ZW58MHx8fHwxNzg1MjQ4MDIzfDA&ixlib=rb-4.1.0&q=85';

export const STATS = [
  { value: '2011', label: 'Investisseur depuis' },
  { value: '42', label: 'Sociétés en portefeuille' },
  { value: '9', label: 'Sorties & acquisitions' },
  { value: '$140M+', label: 'Capital déployé' },
];

export const CHAPTERS = [
  {
    n: '01',
    title: 'La conviction avant le consensus',
    body:
      "J'écris le premier chèque là où les autres hésitent encore. Les meilleures entreprises paraissent souvent contre-intuitives avant de devenir évidentes.",
  },
  {
    n: '02',
    title: 'Le fondateur d\u2019abord',
    body:
      "Je mise sur des personnes, pas sur des slides. Lucidité, obsession du produit et endurance : trois qualités qui priment sur tout le reste.",
  },
  {
    n: '03',
    title: 'L\u2019infrastructure de la prochaine décennie',
    body:
      "IA appliquée, fintech, climat et logiciel d'entreprise. Je cherche les couches fondatrices sur lesquelles se construiront des milliers d'autres produits.",
  },
  {
    n: '04',
    title: 'Le capital patient',
    body:
      "Bâtir une catégorie prend du temps. J'accompagne sur dix ans, à travers les cycles, avec une gouvernance sobre et une présence discrète mais constante.",
  },
];

export const SECTORS = [
  'IA & Infrastructure',
  'Fintech',
  'Climat & Hardtech',
  'Logiciel d\u2019entreprise',
  'Cybersécurité',
  'Consumer',
];

export const PORTFOLIO = [
  {
    id: 'aperture',
    name: 'Aperture Labs',
    sector: 'IA & Infrastructure',
    stage: 'Seed · 2021',
    url: '#',
    description:
      "Plateforme d'orchestration de modèles d'IA pour les grandes entreprises.",
  },
  {
    id: 'northwind',
    name: 'Northwind',
    sector: 'Fintech',
    stage: 'Série A · 2020',
    url: '#',
    description:
      'Infrastructure de paiements transfrontaliers pensée pour les PME.',
  },
  {
    id: 'cobalt',
    name: 'Cobalt',
    sector: 'Climat & Hardtech',
    stage: 'Seed · 2022',
    url: '#',
    description:
      "Stockage d'énergie longue durée à base de fer, à coût radicalement réduit.",
  },
  {
    id: 'meridian',
    name: 'Meridian',
    sector: 'Logiciel d\u2019entreprise',
    stage: 'Série A · 2019',
    url: '#',
    description:
      "Système d'exploitation de la donnée pour les équipes financières.",
  },
  {
    id: 'halcyon',
    name: 'Halcyon',
    sector: 'Cybersécurité',
    stage: 'Seed · 2021',
    url: '#',
    description:
      "Détection et réponse aux menaces pilotées par l'IA, en temps réel.",
  },
  {
    id: 'vantage',
    name: 'Vantage',
    sector: 'Consumer',
    stage: 'Pré-seed · 2023',
    url: '#',
    description:
      'Gestion de patrimoine mobile pensée pour la nouvelle génération.',
  },
];

